// extracted by mini-css-extract-plugin
export default {"content":"GetVideoForPages_content__0KrVs","icon":"GetVideoForPages_icon__82qOV","spin":"GetVideoForPages_spin__4HY0G"};